import styled from "styled-components";

export const AccordionWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.primaryLightFill};
  transition: all;
  scroll-margin-top: 60px;

  > div {
    margin-block-start: 0;
  }

  .divider {
    > div {
      width: 100%;
      height: 100%;
      background: ${({ theme }) => theme.colors.primaryRulerTint50};
    }
    margin-top: 0;
    margin-bottom: 0;
    height: 0.5px;
    padding-left: 10%;
    padding-right: 10%;
    background: ${({ theme }) => theme.colors.primaryRulerTint15};
  }

  div[class*="accordion__body"] {
    background: ${({ theme }) => theme.colors.neutralsBackgroundInactive};
  }
`;

export const LabelWrapper = styled.div`
  > label {
    font-weight: 500;
  }
`;
